import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import Icon, { IconTypes } from "../../../common/Icon";
import { Paper } from "@mui/material";

function ApplicationTrackSelection({ event, changeTrack, onContinue }) {
  const magdalaExperiences = [
    { text: "An in-depth learning experience" },
    { text: "Weekly readings to help reinforce learning" },
    { text: "Live weekly classes" },
    { text: "The ability to interact with the instructor & classmates" },
    { text: "A certificate of completion" }
  ];

  const auditOnlyLCSMemberExperiences = [
    { text: "An in-depth learning experience" },
    { text: "Daily video reflections" },
    { text: "Living Advent with our worldwide ICC family" },
  ];

  const auditOnlyMemberExperiences = [
    { text: "An in-depth learning experience" },
    { text: "Weekly readings to help reinforce learning" }, 
    { text: "Live weekly classes" },
    { text: "The ability to interact with the instructor & classmates" },
  ];

  const memberExperiences = [
    { bold: "All content,", text: "completely free", auditCheckmark: true },
    { bold: "Live weekly webinar", text: "with learners just like you", auditCheckmark: true },
    { bold: "Live weekly interaction", text: "with the instructor", auditCheckmark: true },
    { bold: "Weekly recordings", text: "of each lecture", auditCheckmark: true },
    { bold: "Weekly quizzes", text: "to help reinforce learning", auditCheckmark: false },
    { bold: "Certificate of completion", text: "once you finish the course", auditCheckmark: false }
  ];

  return (
    <div className="ApplicationTrackSelection">
      { event.magdala ? (
          <div className="ApplicationTrackSelection-audit-only">
            <div>
              <div className="headline">Let's finish<br/> your application</div>
              <div className="regular-text">You are applying for <span className="primary-text">{event.title}</span></div>
              <div className="regular-text">Here is what the full student experience includes:</div>
              <Paper className="audit-only-experiences" elevation={4}>
                <div className="experiences-title">The student experience</div>
                <div className="audit-only-experience-list">
                  {magdalaExperiences.map((experience, index) => (
                    <div className="experience-row" key={`magdala-experience-${index}`}>
                      <Icon 
                        type={IconTypes.Complete}
                        className="experience-icon-complete"
                      />
                      <div className="experience-text">
                        {experience.text}</div>
                      </div>
                  ))}
                </div>
              </Paper>
            </div>
            <div className="audit-only-actions">
              <div>
                <Button variant="contained" color="secondary" onClick={() => onContinue("audit")}>Apply Now</Button>
              </div>
            </div>
          </div>
        ) : (!event.course.certificateApplication.length && event.title === "Rediscovering Advent") ? (
          <div className="ApplicationTrackSelection-audit-only">
            <div>
              <div className="headline">Let's finish<br/> your application</div>
              <div className="regular-text">You are applying for <span className="primary-text">{event.title}</span></div>
              <div className="regular-text">Here is what the full student experience includes:</div>
              <Paper className="audit-only-experiences" elevation={4}>
                <div className="experiences-title">The student experience</div>
                <div className="audit-only-experience-list">
                  {auditOnlyLCSMemberExperiences.map((experience, index) => (
                    <div className="experience-row" key={`magdala-experience-${index}`}>
                      <Icon 
                        type={IconTypes.Complete}
                        className="experience-icon-complete"
                      />
                      <div className="experience-text">
                        {experience.text}</div>
                      </div>
                  ))}
                </div>
              </Paper>
            </div>
            <div className="audit-only-actions">
              <div>
                <Button variant="contained" color="secondary" onClick={() => onContinue("audit")}>Apply Now</Button>
              </div>
            </div>
          </div>
        ) : (!event.course.certificateApplication.length && event.title !== "Rediscovering Advent") ? (
          <div className="ApplicationTrackSelection-audit-only">
            <div>
              <div className="headline">Let's finish<br/> your application</div>
              <div className="regular-text">You are applying for <span className="primary-text">{event.title}</span></div>
              <div className="regular-text">Here is what the full student experience includes:</div>
              <Paper className="audit-only-experiences" elevation={4}>
                <div className="experiences-title">The student experience</div>
                <div className="audit-only-experience-list">
                  {auditOnlyMemberExperiences.map((experience, index) => (
                    <div className="experience-row" key={`magdala-experience-${index}`}>
                      <Icon 
                        type={IconTypes.Complete}
                        className="experience-icon-complete"
                      />
                      <div className="experience-text">
                        {experience.text}</div>
                      </div>
                  ))}
                </div>
              </Paper>
            </div>
            <div className="audit-only-actions">
              <div>
                <Button variant="contained" color="secondary" onClick={() => onContinue("audit")}>Apply Now</Button>
              </div>
            </div>
          </div>
        ) : (
          <div className="ApplicationTrackSelection-member">
            <div>
              <div className="headline">Choose your student experience</div>
              <div className="regular-text">You are applying for <span className="primary-text">{event.title}</span></div>
              <div className="headline-subtext">
                Both paths open the same course.<br/>The difference is in the type of experience you wish to have. 
              </div>
              <div className="container-track-selection">
                <Paper className="certificate" elevation={4}>
                  <div className="recommended-banner">
                    <Icon type={IconTypes.RatingFilled} className="recommended-icon" size="1x" />
                    <p className="recommended-text">Full Experience</p>
                  </div>
                  <div className="title">Certificate</div>
                  <div className="subtitle">
                    <em>For those who want the full student experience and a certificate of completion at the end.</em>
                  </div>
                  <div className="certificate-banner">
                    <div className="banner-title">The Certificate Experience</div>
                    <div className="banner-subtitle">Read the weekly assigned readings, join us for an in-depth and interactive webinar, and reinforce your learning with weekly quizzes.</div>
                  </div>
                  <div className="member-experience-list">
                    {memberExperiences.map((experience, index) => (
                      <div className="experience-row" key={`member-cert-experience-${index}`}>
                        <Icon 
                          type={IconTypes.Complete}
                          className="experience-icon-complete"
                        />
                        <div className="experience-text">
                          <span className="experience-bold">{experience.bold}</span> {experience.text}
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="container-button">
                    <Button variant="contained" color="secondary" onClick={() => onContinue("certificate")}>
                      Apply Now
                    </Button>
                  </div>   
                </Paper>
                <Paper className="audit" elevation={4}>
                  <div className="title">Audit</div>
                  <div className="subtitle"><em>For those who just want to follow along at their own pace.</em></div>
                  <div className="audit-banner">
                    <div className="banner-title">The Auditing Experience</div>
                    <div className="banner-subtitle">Watch the weekly lecture and read the assigned readings you want without any deadlines or quizzes.</div>
                  </div>
                  <div className="member-experience-list">
                    {memberExperiences.map((experience, index) => (
                      <div className="experience-row" key={`member-audit-experience-${index}`}>
                        <Icon 
                          type={experience.auditCheckmark ? IconTypes.Complete : IconTypes.Dash}
                          className={experience.auditCheckmark ? "experience-icon-complete" : "experience-icon-dash"}
                        />
                        <div className="experience-text">
                          <span className="experience-bold">{experience.bold}</span> {experience.text}
                        </div>
                      </div>
                    ))}
                  </div> 
                  <div className="container-button">
                    <Button variant="contained" color="secondary" onClick={() => onContinue("audit")}>
                      Apply Now
                    </Button>
                  </div>   
                </Paper>
              </div>
            </div>
          </div>
        )
      }
      <div className="regular-text">It takes less than a minute to apply</div>
    </div>
  );
}

ApplicationTrackSelection.propTypes = {
  event: PropTypes.object,
  changeTrack: PropTypes.func,
  onContinue: PropTypes.func
};

export default ApplicationTrackSelection;
